export default __webpack_public_path__ + "static/media/ico-pin.fef2701e.svg";